import { HOST, registerModel } from '@/utils/base';

export default [
    // 供应商+资金公司
    {
        path: HOST + 'coop',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //资金公司管理
            {
                path: 'fundcorp/list',
                component: () => import('@/routes/coop/fundcorp/list'),
            },
            //资金公司新增
            {
                path: 'fundcorp/add',
                component: () => import('@/routes/coop/fundcorp/add'),
            },
            //资金公司编辑
            {
                path: 'fundcorp/edit',
                component: () => import('@/routes/coop/fundcorp/edit'),
            },
            //资金公司编辑
            {
                path: 'fundcorp/info',
                component: () => import('@/routes/coop/fundcorp/info'),
            },
            //供应商管理
            {
                path: 'supplier/list',
                component: () => import('@/routes/coop/supplier/list'),
            },
            // 供应商管理 - 添加
            {
                path: 'supplier/add',
                component: () => import('@/routes/coop/supplier/add'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 供应商管理 - 详情
                path: 'supplier/info',
                component: () => import('@/routes/coop/supplier/info'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 供应商管理 - 编辑
                path: 'supplier/edit',
                component: () => import('@/routes/coop/supplier/edit'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            }
        ],
    },
    // 物流装卸公司
    {
        path: HOST + 'coop',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            {
                //物流装卸公司管理
                path: 'logistics/list',
                component: () => import('@/routes/coop/logistics/list'),
            },
            {
                // 物流装卸公司管理 - 添加
                path: 'logistics/add',
                component: () => import('@/routes/coop/logistics/add'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 物流装卸公司管理 - 详细
                path: 'logistics/info',
                component: () => import('@/routes/coop/logistics/info'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 物流装卸公司管理 - 编辑
                path: 'logistics/edit',
                component: () => import('@/routes/coop/logistics/edit'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            }
        ],
    },
    // 客户管理
    {
        path: HOST + 'coop',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //客户管理
            {
                path: 'custom/list',
                component: () => import('@/routes/coop/custom/list'),
            },
            //客户管理新增
            {
                path: 'custom/add',
                component: () => import('@/routes/coop/custom/add'),
            },
            //客户管理编辑
            {
                path: 'custom/edit',
                component: () => import('@/routes/coop/custom/edit'),
            },
            //客户管理详细
            {
                path: 'custom/info',
                component: () => import('@/routes/coop/custom/info'),
            },
        ],
    },
    // 仓库管理
    {
        path: HOST + 'coop',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //仓库管理
            {
                path: 'warehouse/list',
                component: () => import('@/routes/coop/warehouse/list'),
            },
            //仓库管理新增
            {
                path: 'warehouse/add',
                component: () => import('@/routes/coop/warehouse/add'),
            },
            //仓库管理编辑
            {
                path: 'warehouse/edit',
                component: () => import('@/routes/coop/warehouse/edit'),
            },
        ],
    },
    // 投标主体公司
    {
        path: HOST + 'coop',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            {
                //投标主体公司管理
                path: 'biddingcorp/list',
                component: () => import('@/routes/coop/biddingcorp/list'),
            },
            {
                // 投标主体公司管理 - 添加
                path: 'biddingcorp/add',
                component: () => import('@/routes/coop/biddingcorp/add'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 投标主体公司管理 - 详细
                path: 'biddingcorp/info',
                component: () => import('@/routes/coop/biddingcorp/info'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 投标主体公司管理 - 编辑
                path: 'biddingcorp/edit',
                component: () => import('@/routes/coop/biddingcorp/edit'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            }
        ],
    },
    // 执行公司
    {
        path: HOST + 'coop',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            {
                //执行公司管理
                path: 'execcorp/list',
                component: () => import('@/routes/coop/execcorp/list'),
            },
            {
                // 执行公司管理 - 添加
                path: 'execcorp/add',
                component: () => import('@/routes/coop/execcorp/add'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 执行公司管理 - 详细
                path: 'execcorp/info',
                component: () => import('@/routes/coop/execcorp/info'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 执行公司管理 - 编辑
                path: 'execcorp/edit',
                component: () => import('@/routes/coop/execcorp/edit'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            }
        ],
    },
    // 额度管理
    {
        path: HOST + 'coop',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //额度申请单管理
            {
                path: 'quota/quota_list',
                component: () => import('@/routes/coop/quota/quota_list'),
            },
            //额度申请编辑
            {
                path: 'quota/quota_edit',
                component: () => import('@/routes/coop/quota/quota_edit'),
            },
            //额度申请
            {
                path: 'quota/quota_apply',
                component: () => import('@/routes/coop/quota/quota_apply'),
            },
            //额度申请详情
            {
                path: 'quota/quota_info',
                component: () => import('@/routes/coop/quota/quota_info'),
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/common/coop_router.js